/**
 * App session handed to the OmmnioSign page by the RN DigitalSignatureScreen.
 * Memory only: never written to cookies, storage or Redux auth. See rn-security spec §1.6.
 */
export const WEBVIEW_SESSION_GLOBAL = '__OMMNIOSIGN_WEBVIEW_SESSION__';
export const WEBVIEW_SESSION_MESSAGE = 'OMMNIOSIGN_WEBVIEW_SESSION';

let current = null;

const isValid = session =>
  Boolean(
    session &&
    typeof session.token === 'string' &&
    session.token.length > 0 &&
    typeof session.companyId === 'string' &&
    session.companyId.length > 0,
  );

export const setWebViewSession = session => {
  current = isValid(session) ? { token: session.token, companyId: session.companyId } : null;
  return current;
};

export const clearWebViewSession = () => {
  current = null;
};

export const getWebViewSession = () => current;

export const hasWebViewSession = () => Boolean(current);

export const readWebViewSessionFromBridge = () =>
  typeof window === 'undefined' ? null : window[WEBVIEW_SESSION_GLOBAL] || null;

export const parseWebViewSessionMessage = data => {
  try {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    return parsed?.type === WEBVIEW_SESSION_MESSAGE && isValid(parsed.session)
      ? parsed.session
      : null;
  } catch {
    return null;
  }
};
